export const LogoMark = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <rect x="7" y="29" width="14" height="7" fill="#39415a" />
    <rect x="25" y="29" width="16" height="7" fill="#232839" />
    <rect x="14" y="38" width="14" height="7" fill="#39415a" />
    <rect x="31" y="38" width="10" height="7" fill="#232839" />
    <path d="M4 26 L24 7 L44 26 L37.5 26 L24 13.5 L10.5 26 Z" fill="#f97316" />
  </svg>
);

export const Logo = () => (
  <a href="#top" data-testid="logo-home-link" className="flex items-center gap-3 shrink-0">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display text-2xl tracking-wider text-white">
        BRICKN<span className="text-orange-500">-</span>RIDGE
      </span>
      <span className="block font-mono text-[10px] tracking-[0.4em] text-slate-400 mt-0.5">
        CONSTRUCTION
      </span>
    </span>
  </a>
);
